module.exports = __webpack_public_path__ + "img/logo-dark.fceb7f4e.png";